/**
 * SupervisionStatusBadge
 *
 * Clear visual state for document review status (Unsigned, Needs Edits, High Risk, Overdue, Signed).
 * Subtle but consistent; reserve strong emphasis for true risk to avoid alarm fatigue.
 */

import { Badge } from '@mantine/core';
import {
  DocumentReviewStatusLabels,
  DocumentReviewStatusColors,
  type DocumentReviewStatus,
} from '../types';

interface SupervisionStatusBadgeProps {
  status: DocumentReviewStatus;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  variant?: 'filled' | 'light' | 'outline' | 'dot';
}

export function SupervisionStatusBadge({
  status,
  size = 'sm',
  variant = 'light',
}: SupervisionStatusBadgeProps): JSX.Element {
  const label = DocumentReviewStatusLabels[status];
  const color = DocumentReviewStatusColors[status];

  return (
    <Badge size={size} variant={variant} color={color}>
      {label}
    </Badge>
  );
}
